import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppConfig } from '@/types';

interface AppState {
  config: AppConfig | null;
  isInitialized: boolean;
  theme: 'light' | 'dark';
  sidebarOpen: boolean;
  loading: boolean;
}

const initialState: AppState = {
  config: null,
  isInitialized: false,
  theme: 'light',
  sidebarOpen: false,
  loading: false,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setConfig: (state, action: PayloadAction<AppConfig>) => {
      state.config = action.payload;
    },
    setInitialized: (state, action: PayloadAction<boolean>) => {
      state.isInitialized = action.payload;
    },
    toggleTheme: (state) => {
      state.theme = state.theme === 'light' ? 'dark' : 'light';
    },
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload;
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const {
  setConfig,
  setInitialized,
  toggleTheme,
  setTheme,
  toggleSidebar,
  setSidebarOpen,
  setLoading,
} = appSlice.actions;

export default appSlice.reducer; 